export const DEAL_MODAL_OPEN = "DEAL_MODAL_OPEN";
export const DEAL_MODAL_CLOSE = "DEAL_MODAL_CLOSE";
export const DEAL_MODAL_SHARE_MODAL_OPEN = "DEAL_MODAL_SHARE_MODAL_OPEN";
export const DEAL_MODAL_SHARE_MODAL_CLOSE = "DEAL_MODAL_SHARE_MODAL_CLOSE";
export const DEAL_MODAL_ASSETS_SELECT = "DEAL_MODAL_ASSETS_SELECT";
export const DEAL_MODAL_SHARE_STATUS_SELECT = "DEAL_MODAL_SHARE_STATUS_SELECT";

export const closeDealModal = () => (dispatch) =>
  dispatch({
    type: DEAL_MODAL_CLOSE,
  });

export const openDealModal =
  (deal, mail = {}, parent = "Asset") =>
  (dispatch) =>
    dispatch({
      type: DEAL_MODAL_OPEN,
      payload: { deal, mail },
      meta: { parent },
    });

export const closeShareModal = () => (dispatch) =>
  dispatch({
    type: DEAL_MODAL_SHARE_MODAL_CLOSE,
  });

export const openShareModal = () => (dispatch) =>
  dispatch({
    type: DEAL_MODAL_SHARE_MODAL_OPEN,
  });

export const selectAssets = (assets) => (dispatch) =>
  dispatch({
    type: DEAL_MODAL_ASSETS_SELECT,
    payload: { assets },
  });

export const selectShareStatus =
  (shareStatus, sharedBrokers = []) =>
  (dispatch) =>
    dispatch({
      type: DEAL_MODAL_SHARE_STATUS_SELECT,
      payload: { shareStatus, sharedBrokers },
    });
